import { ironOptions } from 'shared/misc/iron';
import { getCookiesMap } from '../actions/getCookiesMap';

export async function getAuthCookie() {
  const cookieMap = await getCookiesMap();
  return cookieMap?.[ironOptions.cookieName];
}
